export default function (uku) {
    this.users = ['momoko', 'sakura', 'lily', 'lowe'];
};



//////////////////
// WEBPACK FOOTER
// ./resources/js/example15.js
// module id = 16
// module chunks = 0